import { render, staticRenderFns } from "./PartsSales.vue?vue&type=template&id=1c935d75&scoped=true&"
import script from "./PartsSales.vue?vue&type=script&lang=js&"
export * from "./PartsSales.vue?vue&type=script&lang=js&"
import style0 from "./PartsSales.vue?vue&type=style&index=0&id=1c935d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c935d75",
  null
  
)

export default component.exports